import { render } from "./App.vue?vue&type=template&id=4488c0c3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4488c0c3&lang=less"

import exportComponent from "D:\\workspaces\\routest\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__